/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Wait from '@react/react-spectrum/Wait';
import SimplifiedWait from '@ccxi/ccxi-shared-components/src/Wait';
import AppLoader from '../../stores/appLoader';
import './busy.scss';

class Busy extends Component {
    render() {
        const {
            localizedLoadingText,
        } = AppLoader;

        return (
            <div className="activityIndicator">
                <div className="busy" role="status" aria-label={localizedLoadingText}>
                    {/* In case of CCD use SimplifiedWait or else use react-spectrum's Wait */}
                    { window.appContext ? <SimplifiedWait size="L" /> : <Wait size="L" /> }
                </div>
                <div className="busy-text">
                    <span>{localizedLoadingText}...</span>
                </div>
            </div>
        );
    }
}

export default observer(Busy);
